import type { ReactElement } from 'react';

import { OneOrMany } from '@utilities/helpers/OneOrMany';

import type { BaseButtonProps } from '../../Button';
import type { FeedbackButtonProps, FeedbackButtonVariant } from '../../FeedbackButton';
import { FeedbackButton } from '../../FeedbackButton';
import type { FeedbackButtonGroupProps } from '../../FeedbackButtonGroup';
import { FeedbackButtonGroup } from '../../FeedbackButtonGroup';
import styles from './Reactions.module.scss';

type ReactionVariant = FeedbackButtonVariant;

interface ReactionsGroupProps extends FeedbackButtonGroupProps {
  children?: OneOrMany<ReactElement<ReactionsOptionProps, typeof ReactionsOption>>;
}

const ReactionsGroup = ({ children, ...buttonProps }: ReactionsGroupProps) => {
  return (
    <FeedbackButtonGroup {...buttonProps}>
      {OneOrMany.asArray(children).map((child) => {
        return <FeedbackButton {...child.props} key={child.key} />;
      })}
    </FeedbackButtonGroup>
  );
};

type ReactionsOptionProps = FeedbackButtonProps & FeedbackButtonProps;

const ReactionsOption = ({ variant, count, onToggle, ...buttonProps }: ReactionsOptionProps) => {
  return <FeedbackButton {...buttonProps} variant={variant} count={count} onToggle={onToggle} />;
};

interface ReactionsProps extends Omit<BaseButtonProps, 'children'> {
  children?: OneOrMany<ReactElement<any, typeof ReactionsOption | typeof ReactionsGroup>>;
}

const Reactions = ({ children }: ReactionsProps) => {
  return (
    <div className={styles['self']}>
      {OneOrMany.asArray(children).map((child) => {
        if (child.type === ReactionsGroup) {
          return (
            <ReactionsGroup {...child.props} key={child.key}>
              {...child.props.children}
            </ReactionsGroup>
          );
        } else {
          if (child.type === ReactionsOption) {
            return <ReactionsOption {...child.props} key={child.key} />;
          } else {
            return false;
          }
        }
      })}
    </div>
  );
};

export default Reactions;

export { type ReactionVariant, ReactionsOption, ReactionsGroup };
